import React, { useRef, useContext, useEffect } from "react";
import { useMutation } from "@apollo/react-hooks";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useSnackbar } from "notistack";
import { LoginForm } from "./children";
import { POST_VERIFY_PHONE } from "../../queries";
import { LoginWrapper } from "./LoginWrapper";
import { useTranslation } from "react-i18next";
import parsePhoneNumber from "libphonenumber-js";
import { usePreferences } from "../../hooks";
import { COUNTRY_DATE_FORMAT } from "../../constants";
import { BrandThemeContext } from "../../contexts";

const Login = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const { updatePreferences } = usePreferences();
  const { themeName } = useContext(BrandThemeContext);
  const { group_code } = useParams();

  useEffect(() => {
    if (!group_code) {
      sessionStorage.removeItem("Group_Code");
      return;
    }

    sessionStorage.setItem("Group_Code", group_code);
  }, [group_code]);

  const credentials = useRef({});
  const { enqueueSnackbar } = useSnackbar();

  const [postVerifyPhone, { loading }] = useMutation(POST_VERIFY_PHONE, {
    onError: () => {
      enqueueSnackbar(t("auth.login.error_api"), { variant: "error" });
    },
    onCompleted: ({ verifyPhone }) => {
      if (
        verifyPhone &&
        verifyPhone.status &&
        verifyPhone.status === "success"
      ) {
        const { search } = location;

        history.push({
          pathname: "/login/2FA",
          search,
          state: { ...credentials.current, brand: themeName }
        });

        // Set dateFormat preference based on phone country
        const phoneNumber = parsePhoneNumber(credentials.current.phone);

        if (phoneNumber && phoneNumber.country) {
          const dateFormat = COUNTRY_DATE_FORMAT[phoneNumber.country]
            ? COUNTRY_DATE_FORMAT[phoneNumber.country]
            : COUNTRY_DATE_FORMAT.default;

          updatePreferences({ dateFormat });
        }
      } else {
        enqueueSnackbar(t("auth.login.error_api"), { variant: "error" });
      }
    }
  });

  const onSubmit = async ({ phone, has_sms = false }) => {
    credentials.current = { ...credentials.current, phone, has_sms };

    postVerifyPhone({
      variables: {
        body: {
          phone_number: phone,
          has_sms,
          brand: themeName
        }
      }
    });
  };

  return (
    <LoginWrapper showLogo={true}>
      <LoginForm onSubmit={onSubmit} formSubmitting={loading} />
    </LoginWrapper>
  );
};

export default Login;
